import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";

export default function ResendInvoiceButton({ sid }) {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/billing/${sid}/resend-invoice`);
      const who = data.parent && data.copy ? "the parent and you" : data.parent ? "the parent (your copy failed)" : "you (the parent's email failed)";
      toast.success(`Invoice ${data.invoice_no} resent to ${who}.`);
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail) || "Could not resend the invoice.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button onClick={resend} disabled={busy} data-testid={`resend-invoice-${sid}`}
      className="inline-flex items-center gap-1 rounded-full border-2 border-blue-400 text-blue-200 px-3 py-1 text-xs font-semibold hover:bg-blue-500/20 disabled:opacity-60 whitespace-nowrap">
      {busy ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} />} Resend invoice
    </button>
  );
}
